export const GET_ONBOARD_STATUS_REQUEST = 'GET_ONBOARD_STATUS_REQUEST';
export const GET_ONBOARD_STATUS_SUCCESS = 'GET_ONBOARD_STATUS_SUCCESS';
export const GET_ONBOARD_STATUS_FAILURE = 'GET_ONBOARD_STATUS_FAILURE';
